import cx from "classnames";
import React, { useEffect } from "react";

import { useBreakpoints } from '@/hooks/use-breakpoints';
import { useChangeEffect } from "@/hooks/useChangeEffect";
import { useDocumentUrlHandler } from "@/hooks/useDocumentUrlHandler";
import { usePageBottom } from '@/hooks/usePageBottom';
import { useScriptInsert } from "@/hooks/useScriptInsert";

import {
  ModalsProvider,
  openModal,
} from "@/services/modalsProvider";

import { MODAL_NAMES, CRM_PLUGIN_SCRIPT } from "@/utils/constants";
import { clearAllScrollLocks } from "@/utils/scroll-locker";

import css from "./BasePage.module.scss";

const DocumentModal = React.lazy(() => {
  return import("@/components/modals/DocumentModal");
});
const StartModal = React.lazy(() => {
  return import('@/components/modals/StartModal');
});
const NavMenuModal = React.lazy(() => {
  return import('@/components/modals/NavMenuModal');
});
const AuthModal = React.lazy(() => {
  return import('@/components/modals/AuthModal');
});

const modals = {
  [MODAL_NAMES.document]: {
    component: DocumentModal,
  },
  [MODAL_NAMES.start]: {
    component: StartModal,
  },
  [MODAL_NAMES.navigation]: {
    component: NavMenuModal,
  },
  [MODAL_NAMES.auth]: {
    component: AuthModal,
  },
};

const BasePage = ({ children, wrapperClassName, customMenuModalProps }) => {
  const bps = useBreakpoints();
  const isBottomReached = usePageBottom();

  useScriptInsert({ innerScript: CRM_PLUGIN_SCRIPT });
  useDocumentUrlHandler();

  useChangeEffect(() => {
    if (bps.tablet && isBottomReached) {
      openModal({
        id: MODAL_NAMES.auth,
        modalName: MODAL_NAMES.auth,
      });
    }
  }, [isBottomReached]);

  useEffect(() => {
    return () => {
      clearAllScrollLocks();
    };
  }, []);

  return (
    <React.Fragment>
      <div
        className={cx(wrapperClassName)}
      >
        {children}
      </div>
      <ModalsProvider modals={modals} />
    </React.Fragment>
  );
};

export default BasePage;
